// UTM + first-touch source capture.
// Stores UTM params and original referrer in sessionStorage on first hit
// so they survive client-side route changes and are attached to every form payload.

const KEY = "renvia.attribution";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function captureAttribution() {
  if (typeof window === "undefined") return {};
  try {
    const existing = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (existing) return existing;

    const params = new URLSearchParams(window.location.search);
    const attribution = {
      first_touch_page: window.location.pathname + window.location.search,
      referrer: document.referrer || null,
    };
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) attribution[k] = v;
    });
    sessionStorage.setItem(KEY, JSON.stringify(attribution));
    return attribution;
  } catch {
    return {};
  }
}

export function getAttribution() {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}
